/**
 * Raised-well fill only. Field primitives must call `useFieldFillClass()` so
 * page-sited wells lift to `--card` instead of matching the linen.
 */
export const fieldSurfaceClass = "bg-background"

/** Shared control radius — buttons, fields, selects, tabs, badges. Chip and Switch stay pills. */
export const controlRadiusClass = "rounded-[var(--radius-brand-button)]"

/** Shared card / dialog / alert / empty-state radius. */
export const cardRadiusClass = "rounded-[var(--radius-brand-card)]"
